import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

const ReloadTracker = () => {
    const RELOAD_LIMIT = 2;
    const TIME_LIMIT = 5000;
    const STORAGE_KEY = "reload_tracker";
    const queryClient = useQueryClient();

    useEffect(() => {
        const now = Date.now();
        let reloads = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

        reloads = reloads.filter(timestamp => now - timestamp < TIME_LIMIT);

        reloads.push(now);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(reloads));

        if (reloads.length >= RELOAD_LIMIT) {
            triggerFunction();
            localStorage.removeItem(STORAGE_KEY);
        }
    }, []);

    const triggerFunction = async () => {
        // alert("Reload limit reached! Function executed.");
        queryClient.refetchQueries().then(() => {
        });
    };

    return null;
};

export default ReloadTracker;
